// extracted by mini-css-extract-plugin
module.exports = {"lineNotify":"BaseLineNotify_lineNotify_1DNLf","baseButton":"BaseLineNotify_baseButton_1UPuw"};